export default {


  index() {
    return env.API.get('/admin/table');
  },


  update(id, data) {
    return env.API.put(`/admin/${id}/restrictions`, data);
  },
}
